import React, {useEffect} from 'react';

import * as analytics from 'analytics/Analytics';
import {assert} from 'Asserts';
import {STORABLE_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {getStorableLabel} from 'relevant-items/getStorableRelevantItemsRowData';
import getTestProps from 'test/lib/cypress/getTestProps';
import APIUtil from 'util/APIUtil';

import StorableRelevantItemsSection from './StorableRelevantItemsSection';

interface Props {
  storableId: string;
}

export default function StorableRelevantItemsView(props: Props): JSX.Element {
  assert(APIUtil.isStorable(props.storableId), 'Expected a storable ID');

  useEffect(() => {
    analytics.trackEvent(STORABLE_ANALYTICS_ACTIONS.VIEWED_STORABLE_RELEVANT_ITEMS, {
      storable_id: props.storableId,
      storable_type: getStorableLabel(props.storableId),
    });
  }, [props.storableId]);

  return (
    <div
      className="react-tab-container"
      {...getTestProps({component: 'StorableRelevantItemsView', element: 'root'})}
    >
      <StorableRelevantItemsSection storableId={props.storableId} />
    </div>
  );
}
